import { CompanyWithSitesMinifiedRowType } from '@api';
import { CompanySiteOptionType } from '../../../../common';

type GetCompanySitesOptionsReturnType = {
  companySiteOptions: CompanySiteOptionType[];
};

export const getCompanySitesOptions = (
  companies: CompanyWithSitesMinifiedRowType[]
): GetCompanySitesOptionsReturnType => {
  const companySiteOptions =
    companies.flatMap((company) =>
      company.sites.map((site) => ({
        value: site.id,
        label: `${company.name} - ${site.city}, ${site.country}`,
        companyName: company.name,
        companyId: company.id,
      }))
    ) ?? [];

  return {
    companySiteOptions,
  };
};
